import { Navigate, Outlet } from 'react-router';
import { paths } from 'config/paths';
import useMarketAndCatalogRoutes from 'hooks/useMarketAndCatalogRoutes';

const MarketRouteAccess = ({ path }: { path: string }) => {
  const { showMarketRoute, showCatalogRoute } = useMarketAndCatalogRoutes();

  switch (path) {
    case 'catalog-market':
      return showCatalogRoute ? <Outlet /> : null;
    case 'market':
      // Catalog-only buyers have no traditional market — send them to the catalog.
      return showCatalogRoute && !showMarketRoute ? <Navigate to={paths.catalogMarket()} replace /> : <Outlet />;
    default:
      return <Outlet />;
  }
};

export default MarketRouteAccess;
